import { render, staticRenderFns } from "./RelationTab.vue?vue&type=template&id=222e5212&scoped=true&"
import script from "./RelationTab.vue?vue&type=script&lang=js&"
export * from "./RelationTab.vue?vue&type=script&lang=js&"
import style0 from "./RelationTab.vue?vue&type=style&index=0&id=222e5212&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222e5212",
  null
  
)

export default component.exports